import { useState } from 'react'

import dayjs from 'dayjs'

import { useBillingDetails } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { ChangePaymentMethodModal } from '../Modals/ChangePaymentMethodModal'

export const PaymentMethodCard = () => {
  const { data: billingDetails } = useBillingDetails()
  const [changePaymentMethod, setChangePaymentMethod] = useState<boolean>()

  return (
    <Card>
      <Card.Header
        title="Payment method"
        action={
          <Button
            variant="outline"
            type="button"
            onClick={() => setChangePaymentMethod(true)}
          >
            Change
          </Button>
        }
      />
      <Card.Content>
        <div>Ending with {billingDetails?.card?.lastFourDigits}</div>
        <div>
          Expires {billingDetails?.card?.expirationMonth}/
          {billingDetails?.card?.expirationYear} . Last updated{' '}
          {dayjs(billingDetails?.card?.updatedAt).format('MMMM D, YYYY')}
        </div>
      </Card.Content>
      {changePaymentMethod && (
        <ChangePaymentMethodModal
          open={changePaymentMethod}
          onClose={() => setChangePaymentMethod(false)}
        />
      )}
    </Card>
  )
}
